var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPerfilActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.556,
    height: 16.765,
    viewBox: "0 0 15.556 16.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{opacity:.84}.cls-2{fill:#9e9e9e}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-perfil-active",
    className: "cls-1",
    transform: "translate(-4.823 -6.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1176",
    "data-name": "Grupo 1176",
    transform: "translate(1.101 1.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_perm_identity_24px",
    d: "M11.878 4.9a3.874 3.874 0 0 0-3.889 3.877 3.809 3.809 0 0 0 3.889 3.877 3.809 3.809 0 0 0 3.889-3.877A3.874 3.874 0 0 0 11.878 4.9zm0 8.592c-2.628 0-7.778 1.258-7.778 3.877V18s1.99 3.667 7.778 3.667S19.656 18 19.656 18v-.629c0-2.517-5.15-3.879-7.778-3.879z",
    className: "cls-2",
    transform: "translate(-.378 .208)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerfilActive);
export default __webpack_public_path__ + "static/media/ic-perfil-active.90766a875686ba74bed0dfa318ff9523.svg";
export { ForwardRef as ReactComponent };